var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaSupportDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic support",
    clipPath: "url(#clip0_9146_76212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic support"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7291 10.9396L17.1485 9.0154C16.7081 4.99153 13.7706 1.78906 9.20215 1.78906C4.05171 1.78906 1 5.37802 1 10.0122C1 13.3362 2.72412 14.852 3.42675 17.1682C3.78126 18.3359 4.83656 19.1491 6.05633 19.1491H13.9396C15.2453 19.1491 16.37 18.2272 16.6267 16.9471L17.1055 14.5587L18.1325 14.0005C19.2481 13.3929 19.535 11.9209 18.7291 10.9396Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M8.28906 0.875C8.79334 0.875089 9.20215 1.28476 9.20215 1.78906V9.25684C10.2664 9.63321 11.0301 10.6457 11.0303 11.8389C11.0303 12.2617 10.9308 12.6609 10.7598 13.0186L12.9678 15.2266C13.1386 15.3974 13.374 15.4941 13.6143 15.4941H14.0166C14.3326 14.9481 14.9224 14.5801 15.5986 14.5801C16.6076 14.5802 17.4256 15.3983 17.4258 16.4072C17.4258 17.4164 16.6078 18.2352 15.5986 18.2354C14.9226 18.2354 14.3337 17.867 14.0176 17.3213H13.6143C12.8824 17.3213 12.1929 17.0365 11.6758 16.5186L9.46777 14.3105C9.11033 14.4814 8.71164 14.5801 8.28906 14.5801C6.77522 14.5801 5.54785 13.3527 5.54785 11.8389C5.54801 10.6459 6.31103 9.63338 7.375 9.25684V1.78906C7.375 1.28471 7.78471 0.875 8.28906 0.875Z",
    fill: "#2894FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaSupportDefault);
export default __webpack_public_path__ + "static/media/figma-support-default.2d67edc8c5596940217d6e91c10be7e2.svg";
export { ForwardRef as ReactComponent };